(function ($) {
    $(function() {
        $('.responsive-table').each(function () {
            initializeResponsiveTable($(this));
        });
    });
    
    $.fn.responsiveTable = function(options) {
        return this.each(function () {
            initializeResponsiveTable($(this));
        });
    }

    function initializeResponsiveTable($table) {
        $table.wrap("<div class=\"responsive-table__wrapper\"></div>")
              .removeAttr('cellspacing', '')
              .removeAttr('cellpadding', '')
              .removeAttr('bordercolor', '')
              .removeAttr('border', '');
    }
}(jQuery));